import "./styles.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/cyrillic-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/cyrillic-500.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/cyrillic-600.css";
import App from "./App";
const qc = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 1500, refetchOnWindowFocus: true },
  },
});
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);

if (import.meta.env.PROD && "serviceWorker" in navigator)
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });

if (import.meta.env.VITE_SENTRY_DSN)
  import("@sentry/react")
    .then((Sentry) =>
      Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        dataCollection: {
          userInfo: false,
          cookies: false,
          httpHeaders: false,
          httpBodies: [],
          urlQueryParams: false,
          databaseQueryData: false,
          queues: false,
          stackFrameVariables: false,
          frameContextLines: 0,
        },

        beforeSend(event) {
          if (event.request) {
            event.request.url = event.request.url?.split("?")[0];
            delete event.request.cookies;
            delete event.request.headers;
            delete event.request.data;
            delete event.request.query_string;
          }
          return event;
        },
        beforeBreadcrumb(b) {
          if (b.data?.url) b.data.url = String(b.data.url).split("?")[0];
          return b;
        },
      }),
    )
    .catch(() => {});
